import {
  MASTER_CONFIG_ITEM_LIST,
  MASTER_CONFIG_ITEM_LIST_SUCCESS,
  MASTER_CONFIG_ITEM_LIST_FAILURE,
  MASTER_CONFIG_ITEM_CREATE,
  MASTER_CONFIG_ITEM_CREATE_SUCCESS,
  MASTER_CONFIG_ITEM_CREATE_FAILURE,
  MASTER_CONFIG_ITEM_UPDATE,
  MASTER_CONFIG_ITEM_UPDATE_SUCCESS,
  MASTER_CONFIG_ITEM_UPDATE_FAILURE,
} from "./actionType";

// LIST
export const masterConfigItemList = () => ({
  type: MASTER_CONFIG_ITEM_LIST,
});
export const masterConfigItemListSuccess = (data) => ({
  type: MASTER_CONFIG_ITEM_LIST_SUCCESS,
  payload: data,
});
export const masterConfigItemListFailure = (error) => ({
  type: MASTER_CONFIG_ITEM_LIST_FAILURE,
  payload: error,
});

// CREATE
export const masterConfigItemCreate = (data) => ({
  type: MASTER_CONFIG_ITEM_CREATE,
  payload: data,
});
export const masterConfigItemCreateSuccess = (data) => ({
  type: MASTER_CONFIG_ITEM_CREATE_SUCCESS,
  payload: data,
});
export const masterConfigItemCreateFailure = (error) => ({
  type: MASTER_CONFIG_ITEM_CREATE_FAILURE,
  payload: error,
});

// UPDATE
export const masterConfigItemUpdate = (data) => ({
  type: MASTER_CONFIG_ITEM_UPDATE,
  payload: data,
});
export const masterConfigItemUpdateSuccess = (data) => ({
  type: MASTER_CONFIG_ITEM_UPDATE_SUCCESS,
  payload: data,
});
export const masterConfigItemUpdateFailure = (error) => ({
  type: MASTER_CONFIG_ITEM_UPDATE_FAILURE,
  payload: error,
});
